import PropTypes from "prop-types";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  CreatableSelect,
  formatSelectOption,
} from "@sopranodesign/pulse-components";

import { createTag as createTagApi } from "../api";

const TagSelect = ({
  value,
  onChange,
  for: scope = "installs",
  disableCreate = false,
  ...props
}) => {
  const queryClient = useQueryClient();

  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ["tags", { scoped_to: scope }],
  });

  const createTag = useMutation({
    mutationFn: createTagApi,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["tags", { scoped_to: scope }],
      });
    },
  });

  const handleTagChange = async (initialOptions) => {
    const items = initialOptions || [];

    const tags = await Promise.all(
      items.map(async ({ __isNew__: isNew, ...item }) => {
        if (isNew && !disableCreate) {
          const { data } = await createTag.mutateAsync({
            name: item.value,
            scoped_to: scope,
          });
          return { value: data.data.id, label: data.data.name };
        }

        return item;
      }),
    );

    onChange(tags);
  };

  return (
    <CreatableSelect
      closeMenuOnSelect
      isMulti
      isClearable
      isLoading={isLoading}
      options={isSuccess ? data.data.map(formatSelectOption) : []}
      onChange={handleTagChange}
      placeholder="Tags"
      value={
        isSuccess &&
        value &&
        value.map((id) => {
          const value = data.data.find((tag) => tag.id === id);

          if (!value) {
            return null;
          }

          return formatSelectOption(value);
        })
      }
      {...props}
    />
  );
};

TagSelect.propTypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  for: PropTypes.oneOf(["installs"]),
};

export default TagSelect;
